module.exports = __webpack_public_path__ + "static/media/back-extension.2994d6cb.svg";